<cmps-dialog>
    <cmps-dialog-header [hasExpandAction]="true"></cmps-dialog-header>
    <cmps-dialog-body>
        <div class="onppup-body">
            <div
                cmpsObservationController
                [mode]="_ObservationControllerMode.POP_UP"
                [published]="observation?.published"
                [allowedActions]="_allowedActions"
                [enabledActions]="_enabledActions"
                [pending]="
                    observation?.pendingAny &&
                    !observation?.pending?.config &&
                    !observation?.pending?.reload
                "
                [dirty]="observation?.dirty"
                (cancel)="_dialogRef?.close()"
                (share)="observation?.share()"
                (delete)="observation?.delete()"
                (publish)="observation?.publish()"
                (save)="observation?.save()"
            ></div>

            <div
                cmpsObservationNext
                storePathPrefix="observationReview"
                [mode]="_ObservationMode.POP_UP"
                [userId]="_options?.userId"
                [focus]="_options?.focus"
                [draftCommitmentId]="_options?.draftCommitmentId"
                [commitmentId]="_options?.commitmentId"
                (allowedActionsChange)="_allowedActions = $event"
                (enabledActionsChange)="_enabledActions = $event"
                [extraOptions]="_options?.extraOptions"
                #observation
            ></div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
